import React from 'react'
import AdvertisementsList from '../../pages/Commercial/Advertisements/List'
import AdvertisementsCreate from '../../pages/Commercial/Advertisements/Create'
import AdvertisementsUpdate from '../../pages/Commercial/Advertisements/Update'
import AdvertisementsView from '../../pages/Commercial/Advertisements/View'
import PrivateRoute from '../PrivateRoute'
import { CustomSwitch } from '../../components/CustomSwitch'

export const AdvertisementsRouter = (): JSX.Element => (
  <CustomSwitch>
    <PrivateRoute
      path="/commercial/advertisements"
      exact
      component={AdvertisementsList}
    />
    <PrivateRoute
      path="/commercial/advertisements/create"
      exact
      component={AdvertisementsCreate}
    />
    <PrivateRoute
      path="/commercial/advertisements/view/:id"
      exact
      component={AdvertisementsView}
    />
    <PrivateRoute
      path="/commercial/advertisements/update/:id"
      exact
      component={AdvertisementsUpdate}
    />
  </CustomSwitch>
)
